<form [formGroup]="vehicleForm">
  <div class="form-section">
    <div class="row">
      <div class="col-6">
        <div class="mb-3">
          <label for="vehicle_discount_code" class="form-label">{{
            "inputs.vehicle_discount_code" | translate
          }}</label>
          <input
            type="text"
            class="form-control"
            id="vehicle_discount_code"
            required
            formControlName="vehicle_discount_code"
            placeholder="{{ 'inputs.vehicle_discount_code' | translate }}"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="mb-3">
          <label for="details" class="form-label">{{
            "inputs.details" | translate
          }}</label>
          <div class="form-check require-action">
            <input
              class="form-check-input"
              type="checkbox"
              formControlName="vehicle_registered"
            />
            <label class="form-check-label" for="vehicle_registered">
              {{ "inputs.vehicle_registered" | translate }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="mb-3">
          <label for="vehicle_status" class="form-label">{{
            "inputs.status" | translate
          }}</label>
          <div class="input-group">
            <select
              id="vehicle_status"
              class="form-control"
              formControlName="vehicle_status"
            >
              <option value="" disabled selected>
                {{ "inputs.select_option" | translate }}
              </option>
              <option value="new" selected>
                {{ "badge-status_select-stage.new" | translate }}
              </option>
              <option value="used">
                {{ "badge-status_select-stage.used" | translate }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row linea"></div>
  <div class="row">
    <div class="col-3">
      <div class="mb-3">
        <label for="brand" class="form-label"
          >{{ "inputs.brand" | translate }}
          <span class="required">*</span></label
        >
        <ng-select formControlName="vehicle_brand_id" [items]="brands" bindValue="reference" bindLabel="name"
          [placeholder]="'inputs.brand' | translate" [searchable]="true" [clearable]="false"
          (change)="onBrandChange($event?.reference)">
        </ng-select>
      </div>
    </div>
    <div class="col-3">
      <div class="mb-3">
        <label for="model" class="form-label"
          >{{ "inputs.model" | translate }}
          <span class="required">*</span></label
        >
        <ng-select formControlName="vehicle_model_id" [items]="models" bindValue="reference" bindLabel="name"
          [placeholder]="'inputs.model' | translate" [searchable]="true" [clearable]="false">
        </ng-select>
      </div>
    </div>
    <div class="col-3">
      <div class="mb-3">
        <label for="vehicle_trim" class="form-label">{{
          "inputs.vehicle_trim_finish" | translate
        }}</label>
        <input
          type="text"
          class="form-control"
          id="vehicle_trim"
          formControlName="vehicle_trim"
          maxlength="150"
        />
      </div>
    </div>
    <div class="col-3">
      <div class="mb-3">
        <label for="year" class="form-label">{{
          "inputs.year" | translate
        }}</label>
        <input
          type="text"
          class="form-control"
          id="vehicle_model_year"
          required
          formControlName="vehicle_model_year"
          placeholder="{{ 'inputs.year_model' | translate }}"
        />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="mb-3">
        <label for="vehicle" class="form-label">{{
          "inputs.vehicle_trim" | translate
        }}</label>
        <input
          type="text"
          class="form-control"
          id="vehicle"
          required
          formControlName="vehicle"
          placeholder="{{ 'inputs.vehicle_trim' | translate }}"
        />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-4">
      <div class="mb-3">
        <label for="colour" class="form-label">{{
          "inputs.colour" | translate
        }}</label>
        <input
          type="text"
          class="form-control"
          id="colour"
          required
          formControlName="colour"
          placeholder="{{ 'inputs.colour' | translate }}"
        />
      </div>
    </div>
  </div>
  <div class="row linea"></div>

  <!-- Taxonomías vehiculares -->
  <div class="row">
    <div class="col-4">
      <div class="mb-3">
        <label for="fuel" class="form-label">{{ 'inputs.fuel' | translate }} <span class="required">*</span></label>
        <ng-select formControlName="fuel" [items]="fuelOptions" bindValue="key"
          [placeholder]="'inputs.fuel' | translate" [searchable]="false" [clearable]="false">
          <ng-template ng-label-tmp let-item="item">{{ item.label | translate }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.label | translate }}</ng-template>
        </ng-select>
      </div>
    </div>
    <div class="col-4">
      <div class="mb-3">
        <label for="transmission" class="form-label">{{ 'inputs.transmission' | translate }} <span class="required">*</span></label>
        <ng-select formControlName="transmission" [items]="transmissionOptions" bindValue="key"
          [placeholder]="'inputs.transmission' | translate" [searchable]="false" [clearable]="false">
          <ng-template ng-label-tmp let-item="item">{{ item.label | translate }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.label | translate }}</ng-template>
        </ng-select>
      </div>
    </div>
    <div class="col-4">
      <div class="mb-3">
        <label for="drivetrain" class="form-label">{{ 'inputs.drivetrain' | translate }} <span class="required">*</span></label>
        <ng-select formControlName="drivetrain" [items]="drivetrainOptions" bindValue="key"
          [placeholder]="'inputs.drivetrain' | translate" [searchable]="false" [clearable]="false">
          <ng-template ng-label-tmp let-item="item">{{ item.label | translate }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.label | translate }}</ng-template>
        </ng-select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-3">
      <div class="mb-3">
        <label for="emissions_label" class="form-label">{{ 'inputs.emissions_label' | translate }} <span class="required">*</span></label>
        <ng-select formControlName="emissions_label" [items]="emissionsLabelOptions" bindValue="key"
          [placeholder]="'inputs.emissions_label' | translate" [searchable]="false" [clearable]="false">
          <ng-template ng-label-tmp let-item="item">{{ item.label | translate }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item.label | translate }}</ng-template>
        </ng-select>
      </div>
    </div>
    <div class="col-3">
      <div class="mb-3">
        <label for="power" class="form-label">{{ 'inputs.power' | translate }} <span class="required">*</span></label>
        <input type="number" class="form-control" id="power" formControlName="power"
          placeholder="{{ 'inputs.power' | translate }}" min="1" />
      </div>
    </div>
    <div class="col-3">
      <div class="mb-3">
        <label for="doors" class="form-label">{{ 'inputs.doors' | translate }} <span class="required">*</span></label>
        <input type="number" class="form-control" id="doors" formControlName="doors"
          placeholder="{{ 'inputs.doors' | translate }}" min="1" />
      </div>
    </div>
    <div class="col-3">
      <div class="mb-3">
        <label for="seats" class="form-label">{{ 'inputs.seats' | translate }} <span class="required">*</span></label>
        <input type="number" class="form-control" id="seats" formControlName="seats"
          placeholder="{{ 'inputs.seats' | translate }}" min="1" />
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="mb-3">
        <label for="equipment" class="form-label">{{ 'inputs.equipment' | translate }}</label>
        <textarea class="form-control" id="equipment" formControlName="equipment" rows="3" style="resize:none"
          placeholder="{{ 'inputs.equipment_placeholder' | translate }}"></textarea>
      </div>
    </div>
  </div>

  <div class="row linea"></div>
</form>
